import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SharedService } from '../../shared.service';
import { NgForm } from '@angular/forms';
import { errorMsgs, RegExPatterns } from 'src/app/constants';
import { PartnerListDataModel } from 'src/app/management/models/managementModel';
import { FormElement, FormElemFields, PartnerUpdateFormFields } from '../../sharedModel';
import { SharedDataService } from '../../shared-data.service';

@Component({
  selector: 'app-update-csp',
  templateUrl: './update-csp.component.html'
})
export class UpdateCspComponent implements OnInit, OnDestroy {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Input() data: PartnerListDataModel;

  @Input() partnerAppAccessLevels: Array<any>;

  @Input() partnerRegistrationStatuses: Array<any>;

  @Input() formElemConfig: FormElement;

  @Output() formChangeEvent = new EventEmitter();

  @ViewChild('updatePartnerForm', { static: true }) public updatePartnerForm: NgForm;

  idString = '';

  formSubscriber: any;

  regExPatterns = RegExPatterns;

  errorMsgs = errorMsgs;

  destroySubscription = false;

  formElemCustomFields?: PartnerUpdateFormFields;

  columClass?: string;

  constructor(private sharedService: SharedService, private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'updateCspForm');

    this.formSubscriber = this.updatePartnerForm.form.valueChanges.subscribe(x => {
      const tempObj = {
        formData: this.updatePartnerForm
      }
      this.formChangeEvent.emit(tempObj);
    });
    this.operateFields();
  }

  operateFields() {
    if (this.formElemConfig) {
      this.formElemCustomFields = this.formElemConfig?.fields?.partnerUpdateFormFields;
      this.columClass = this.formElemConfig.columClass;
    } else {
      const tempFormElem: FormElement = JSON.parse(JSON.stringify(this.sharedDataService.partnerUpdateFormElemConfig));
      this.formElemCustomFields = tempFormElem.fields?.partnerUpdateFormFields;
      this.columClass = tempFormElem.columClass;
    }
  }

  ngOnDestroy(): void {
    if (this.formSubscriber) {
      this.formSubscriber.unsubscribe();
    }
    this.destroySubscription = true;
  }

}
